function numOrNull(value) {
  if (value == null || value === '') return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
}

/** System / broadcast chat messages use fromUserId=0 (not group, not tenant). */
function isSystemChatMessage(msg, myUserId) {
  if (!msg) return false;
  const from = numOrNull(msg.fromUserId);
  if (from !== 0) return false;
  if (msg.toGroupId) return false;
  if (msg.fromPeopleId != null && msg.fromPeopleId !== '') return false;
  const to = numOrNull(msg.toUserId);
  const me = numOrNull(myUserId);
  return to === 0 || to == null || (me != null && to === me);
}

function isOwnStaffMessage(msg, myUserId) {
  const me = numOrNull(myUserId);
  const from = numOrNull(msg && msg.fromUserId);
  return me != null && from != null && from === me;
}

/**
 * Chat Bot tile on MHome (and NavBar): staff DM/group + tenant.
 * System-channel rows badge the System chat head only.
 */
function shouldCountOnHomeBadge(msg, myUserId) {
  if (!msg) return false;
  if (isSystemChatMessage(msg, myUserId)) return false;
  if (isOwnStaffMessage(msg, myUserId)) return false;
  if (msg.toGroupId) return true;
  if (msg.fromPeopleId != null && msg.fromPeopleId !== '') return true;
  if (msg.senderType === 'tenant') return true;
  const me = numOrNull(myUserId);
  const to = numOrNull(msg.toUserId);
  return me != null && to === me;
}

/** Other party for an incoming direct (staff or tenant) message. */
function incomingDirectPeer(data, myUserId) {
  if (!data) return null;
  const fromPeople = numOrNull(data.fromPeopleId);
  const toPeople = numOrNull(data.toPeopleId);
  if (fromPeople != null) {
    const name = data.fullName || data.displayName || '';
    return {
      personId: fromPeople,
      userId: null,
      displayName: name,
      fullName: name,
    };
  }
  if (toPeople != null) {
    const name = data.fullName || data.displayName || '';
    return {
      personId: toPeople,
      userId: null,
      displayName: name,
      fullName: name,
    };
  }

  const me = numOrNull(myUserId);
  const fromUser = numOrNull(data.fromUserId);
  const toUser = numOrNull(data.toUserId);
  const peerUserId =
    fromUser != null && fromUser !== me
      ? fromUser
      : toUser != null && toUser !== me
        ? toUser
        : null;
  if (peerUserId == null || peerUserId === 0) return null;

  const isFromPeer = fromUser === peerUserId;
  const name =
    (isFromPeer ? data.fromDisplayName : data.toDisplayName) ||
    data.displayName ||
    data.fullName ||
    '';
  return {
    personId: null,
    userId: peerUserId,
    displayName: name,
    fullName: name,
  };
}

function chatsMatchIncomingDirect(chat, data, myUserId) {
  const peer = incomingDirectPeer(data, myUserId);
  if (!peer || !chat) return false;
  if (peer.personId != null) {
    return (
      chat.personId != null && Number(chat.personId) === peer.personId
    );
  }
  if (peer.userId != null) {
    return chat.userId != null && Number(chat.userId) === peer.userId;
  }
  return false;
}

module.exports = {
  isSystemChatMessage,
  shouldCountOnHomeBadge,
  incomingDirectPeer,
  chatsMatchIncomingDirect,
};
